import { Broadcast } from '@/utilities/broadcast';
import { ComponentEvents } from '@/models/events';
import { ComponentStates } from '@/models/componentStates';
import { ViewportObserverEvent } from '@/models/events/viewportObserverEvents';
import { componentObserver } from '@/modules/component/componentObserver';

export class BaseComponent {
  public el: HTMLElement;

  public visibleTrigger: null | number = null;
  public animationDelay: null | number = null;
  public animateOnce: boolean = false;

  constructor(el: HTMLElement) {
    this.el = el;
    this.el.addEventListener(
      ComponentEvents.SHOWN,
      this.revealElement.bind(this)
    );

    this.el.addEventListener(
      ComponentEvents.VIEWPORT_ENTER,
      this.viewportEnter.bind(this)
    );

    this.el.addEventListener(
      ComponentEvents.VIEWPORT_LEAVE,
      this.viewportLeave.bind(this)
    );

    setTimeout(() => {
      Broadcast(el, ComponentEvents.READY);
      componentObserver.refresh(this.el);
    });
  }

  public revealElement() {
    this.el.classList.add(ComponentStates.SHOWN);
  }

  private viewportEnter(e: Event): void {
    if (e.target instanceof HTMLElement && this.visibleTrigger) {
      const detail = (<ViewportObserverEvent>e).detail;
      const target = e.target;

      if (detail.visiblePercentage >= this.visibleTrigger) {
        setTimeout(() => {
          target.classList.add(ComponentStates.ANIMATING);
        }, this.animationDelay || 0);
      }
    }
  }

  private viewportLeave(e: Event): void {
    if (e.target instanceof HTMLElement) {
      if (!this.animateOnce) {
        e.target.classList.remove(ComponentStates.ANIMATING);
      }
    }
  }
}
